/**
 * Created by hernanherreros on 2019-05-28
 */

import * as React from 'react'
import styled, { css } from 'styled-components'
import {
  fontSize,
  FontSizeProps,
  color,
  ColorProps,
  space,
  SpaceProps,
} from 'styled-system'
import { RouterItem } from '../../../config/router.config'

interface Props {
  active?: boolean;
  number: number;
  step: RouterItem;
}

export default ({ active, step, number }: Props) => {
  return (
    <Container px={[2, 3, 4]} py={2} active={active} mx={[0, 1, 2]} my={1}>
      <Progress active={active}/>

      <Number>
        {number}
      </Number>

      <Title color="black" m={0} fontSize={[1, 2]}>{step.label}</Title>
    </Container>
  )
}

export interface ProgressProp {
  active?: boolean;
  first?: boolean;
  last?: boolean;
}

const Progress = styled.div<ProgressProp & any>`
  width: 100%;
  height: 8px;
  margin-bottom: 8px;

  ${({ active }) => active ? css`
    background-color: #47c38c;
  ` : css`
    background-color: #e3e3e3;
  `}

  ${({ first }) => first && css`
    border-radius: 5px 0 0 5px;
  `}
  
  ${({ last }) => last && css`
    border-radius: 0 5px 5px 0;
  `}
`

const Container = styled.div<SpaceProps & any>`
  flex: 1;
  transition: all .2s ease-in-out;
  margin-bottom: 8px;
  
  ${({ active }) => active && css`
    color: #47c38c;
  `}
`

const Number = styled.div`
  font-weight: bold;
  display: inline-block;
  margin-right: 16px;
  padding: 4px;
  text-align: center;
  font-weight: bold;
  background-color: #47c38c;
  border-radius: 1000px;
  width: 30px;
  height: 30px;
  color: #ffffff;
`

const Title = styled.h1<FontSizeProps & ColorProps & SpaceProps>`
  font-weight: bold;
  display: inline-block;

  ${color}
  ${fontSize}
  ${space}
`

const Help = styled.h2<FontSizeProps & ColorProps & SpaceProps>`
  ${color}
  ${fontSize}
  ${space}
`
